import memoize from 'memoize-one';

// memoize-one over `state` misses on every dispatch -- whichever slice it changed -- and
// every miss hands back new objects that invalidate everything built on top of them.
// This memoizes the combiner over what its input selectors return instead, so a result
// lives exactly as long as the data it is computed from.
//
// The input selectors come behind a function and are only read when the selector runs,
// as they were when each selector called them in its own body: reading imported bindings
// while the module loads breaks on import cycles and on tests mocking a selector module.
export const createSelector = (getInputSelectors, combiner) => {
  const memoizedCombiner = memoize(combiner);
  return state => memoizedCombiner(...getInputSelectors().map(selector => selector(state)));
};
